import { Injectable } from '@angular/core';
import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';
import { BehaviorSubject, from, tap } from 'rxjs';

export interface UserInformation {
  email?: string;
  name?: string;
  familyName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _userInfo = new BehaviorSubject<UserInformation | undefined>(undefined);
  user$ = this._userInfo.asObservable();
  constructor() {
    this.loadSession();
  }

  private loadSession() {
    from(fetchAuthSession())
      .pipe(
        tap({
          next: (session) => {
            if (!session.credentials) {
              signInWithRedirect();
            } else {
              const email = session.tokens?.idToken?.payload['email']?.toString();
              const [localPart] = email!.split('@');
              const [name, familyName] = localPart.split('.');
              this._userInfo.next({
                email,
                name,
                familyName: familyName?.split('-')[0],
              });
            }
          },
          error: (err) => {
            console.error(err);
            signInWithRedirect();
          },
        })
      )
      .subscribe();
  }

  getUser(): UserInformation | undefined {
    return this._userInfo.getValue();
  }
}
